export enum PermissaoNome {
  ROLE_CADASTRAR_USUARIO = 'ROLE_CADASTRAR_USUARIO',
  ROLE_REMOVER_USUARIO = 'ROLE_REMOVER_USUARIO',
  ROLE_PESQUISAR_USUARIO = 'ROLE_PESQUISAR_USUARIO',
  ROLE_ALTERAR_SENHA_USUARIO = 'ROLE_ALTERAR_SENHA_USUARIO',
  ROLE_ACESSAR_TODAS_UNIDADES = 'ROLE_ACESSAR_TODAS_UNIDADES',

  ROLE_PESQUISAR_USUARIO_QUESTIONARIO_RESTRITO = 'ROLE_PESQUISAR_USUARIO_QUESTIONARIO_RESTRITO',
  ROLE_CADASTRAR_USUARIO_QUESTIONARIO_RESTRITO = 'ROLE_CADASTRAR_USUARIO_QUESTIONARIO_RESTRITO',
  ROLE_REMOVER_USUARIO_QUESTIONARIO_RESTRITO = 'ROLE_REMOVER_USUARIO_QUESTIONARIO_RESTRITO',

  ROLE_CADASTRAR_EQUIPAMENTO = 'ROLE_CADASTRAR_EQUIPAMENTO',
  ROLE_REMOVER_EQUIPAMENTO = 'ROLE_REMOVER_EQUIPAMENTO',
  ROLE_PESQUISAR_EQUIPAMENTO = 'ROLE_PESQUISAR_EQUIPAMENTO',

  ROLE_CADASTRAR_MEDICAMENTO = 'ROLE_CADASTRAR_MEDICAMENTO',
  ROLE_REMOVER_MEDICAMENTO = 'ROLE_REMOVER_MEDICAMENTO',
  ROLE_PESQUISAR_MEDICAMENTO = 'ROLE_PESQUISAR_MEDICAMENTO',

  ROLE_CADASTRAR_MATERIAL = 'ROLE_CADASTRAR_MATERIAL',
  ROLE_REMOVER_MATERIAL = 'ROLE_REMOVER_MATERIAL',
  ROLE_PESQUISAR_MATERIAL = 'ROLE_PESQUISAR_MATERIAL',

  ROLE_CADASTRAR_LOTE = 'ROLE_CADASTRAR_LOTE',
  ROLE_REMOVER_LOTE = 'ROLE_REMOVER_LOTE',
  ROLE_PESQUISAR_LOTE = 'ROLE_PESQUISAR_LOTE',

  ROLE_CADASTRAR_INVENTARIO = 'ROLE_CADASTRAR_INVENTARIO',
  ROLE_REMOVER_INVENTARIO = 'ROLE_REMOVER_INVENTARIO',
  ROLE_PESQUISAR_INVENTARIO = 'ROLE_PESQUISAR_INVENTARIO',

  ROLE_CADASTRAR_ITEM_INVENTARIO = 'ROLE_CADASTRAR_ITEM_INVENTARIO',
  ROLE_REMOVER_ITEM_INVENTARIO = 'ROLE_REMOVER_ITEM_INVENTARIO',
  ROLE_PESQUISAR_ITEM_INVENTARIO = 'ROLE_PESQUISAR_ITEM_INVENTARIO',

  ROLE_PESQUISAR_CATEGORIA_PRODUTO = 'ROLE_PESQUISAR_CATEGORIA_PRODUTO',
  ROLE_CADASTRAR_CATEGORIA_PRODUTO = 'ROLE_CADASTRAR_CATEGORIA_PRODUTO',
  ROLE_REMOVER_CATEGORIA_PRODUTO = 'ROLE_REMOVER_CATEGORIA_PRODUTO',

  ROLE_PESQUISAR_TIPO_DE_BAIXA_DE_PRODUTO = 'ROLE_PESQUISAR_TIPO_DE_BAIXA_DE_PRODUTO',
  ROLE_CADASTRAR_TIPO_DE_BAIXA_DE_PRODUTO = 'ROLE_CADASTRAR_TIPO_DE_BAIXA_DE_PRODUTO',
  ROLE_REMOVER_TIPO_DE_BAIXA_DE_PRODUTO = 'ROLE_REMOVER_TIPO_DE_BAIXA_DE_PRODUTO',

  ROLE_EFETUAR_BAIXA_DE_PRODUTO = 'ROLE_EFETUAR_BAIXA_DE_PRODUTO',

  ROLE_CADASTRAR_PACIENTE = 'ROLE_CADASTRAR_PACIENTE',
  ROLE_REMOVER_PACIENTE = 'ROLE_REMOVER_PACIENTE',
  ROLE_PESQUISAR_PACIENTE = 'ROLE_PESQUISAR_PACIENTE',

  ROLE_PESQUISAR_RETIRADA = 'ROLE_PESQUISAR_RETIRADA',
  ROLE_SOLICITAR_RETIRADA = 'ROLE_SOLICITAR_RETIRADA',
  ROLE_APROVAR_RETIRADA = 'ROLE_APROVAR_RETIRADA',
  ROLE_EFETUAR_RETIRADA = 'ROLE_EFETUAR_RETIRADA',
  ROLE_EFETUAR_RETIRADA_PARCIAL = 'ROLE_EFETUAR_RETIRADA_PARCIAL',

  ROLE_PESQUISAR_PERFIL = 'ROLE_PESQUISAR_PERFIL',
  ROLE_CADASTRAR_PERFIL = 'ROLE_CADASTRAR_PERFIL',
  ROLE_REMOVER_PERFIL = 'ROLE_REMOVER_PERFIL',

  ROLE_INTEGRACAO_USUARIO = 'ROLE_INTEGRACAO_USUARIO',

  ROLE_CADASTRAR_ROTA_HOMECARE = 'ROLE_CADASTRAR_ROTA_HOMECARE',
  ROLE_REMOVER_ROTA_HOMECARE = 'ROLE_REMOVER_ROTA_HOMECARE',
  ROLE_PESQUISAR_ROTA_HOMECARE = 'ROLE_PESQUISAR_ROTA_HOMECARE',

  ROLE_CADASTRAR_ROTA_COLETA = 'ROLE_CADASTRAR_ROTA_COLETA',
  ROLE_REMOVER_ROTA_COLETA = 'ROLE_REMOVER_ROTA_COLETA',
  ROLE_PESQUISAR_ROTA_COLETA = 'ROLE_PESQUISAR_ROTA_COLETA',

  ROLE_CADASTRAR_QUESTAO = 'ROLE_CADASTRAR_QUESTAO',
  ROLE_REMOVER_QUESTAO = 'ROLE_REMOVER_QUESTAO',
  ROLE_PESQUISAR_QUESTAO = 'ROLE_PESQUISAR_QUESTAO',

  ROLE_CADASTRAR_POI_COLETA = 'ROLE_CADASTRAR_POI_COLETA',
  ROLE_REMOVER_POI_COLETA = 'ROLE_REMOVER_POI_COLETA',
  ROLE_PESQUISAR_POI_COLETA = 'ROLE_PESQUISAR_POI_COLETA',
  
  ROLE_CADASTRAR_POI_HOMECARE = 'ROLE_CADASTRAR_POI_HOMECARE',
  ROLE_REMOVER_POI_HOMECARE = 'ROLE_REMOVER_POI_HOMECARE',
  ROLE_PESQUISAR_POI_HOMECARE = 'ROLE_PESQUISAR_POI_HOMECARE',

  ROLE_CADASTRAR_POI_GLOBAL = 'ROLE_CADASTRAR_POI_GLOBAL',

  ROLE_PESQUISAR_RELATORIO_ATENDIMENTO = 'ROLE_PESQUISAR_RELATORIO_ATENDIMENTO',
  ROLE_PESQUISAR_RELATORIO_KM_PERCORRIDO = 'ROLE_PESQUISAR_RELATORIO_KM_PERCORRIDO',

  ROLE_VISUALIZAR_TODOS_ATENDIMENTOS = 'ROLE_VISUALIZAR_TODOS_ATENDIMENTOS',

  // DASH HOMECARE
  ROLE_VISUALIZAR_DASH_TEMPO_MEDIO_ATENDIMENTO = 'ROLE_VISUALIZAR_DASH_TEMPO_MEDIO_ATENDIMENTO',
  ROLE_VISUALIZAR_DASH_RANK_PROFISSIONAIS = 'ROLE_VISUALIZAR_DASH_RANK_PROFISSIONAIS',
  ROLE_VISUALIZAR_DASH_RESUMO_ATENDIMENTO = 'ROLE_VISUALIZAR_DASH_RESUMO_ATENDIMENTO',
  ROLE_VISUALIZAR_DASH_RESUMO_ATENDIMENTO_ACUMULADO = 'ROLE_VISUALIZAR_DASH_RESUMO_ATENDIMENTO_ACUMULADO',
  ROLE_VISUALIZAR_DASH_MOTIVO_CANCELAMENTO = 'ROLE_VISUALIZAR_DASH_MOTIVO_CANCELAMENTO',

  // DASH COLETA
  ROLE_VISUALIZAR_DASH_RESUMO_ATENDIMENTO_COLETA = 'ROLE_VISUALIZAR_DASH_RESUMO_ATENDIMENTO_COLETA',
  ROLE_VISUALIZAR_DASH_RESUMO_ATENDIMENTO_COLETA_ACUMULADO = 'ROLE_VISUALIZAR_DASH_RESUMO_ATENDIMENTO_COLETA_ACUMULADO',
  ROLE_VISUALIZAR_DASH_RANK_PROFISSIONAIS_COLETA = 'ROLE_VISUALIZAR_DASH_RANK_PROFISSIONAIS_COLETA',
  ROLE_VISUALIZAR_DASH_RESUMO_COLETAS_VENCIDAS = 'ROLE_VISUALIZAR_DASH_RESUMO_COLETAS_VENCIDAS',

  // DASH FARMACIA
  ROLE_VISUALIZAR_DASH_RESUMO_PRESCRICAO = 'ROLE_VISUALIZAR_DASH_RESUMO_PRESCRICAO',

  // DASH CARTEIRA DE CLIENTE
  ROLE_VISUALIZAR_DASH_ANALISE_ENDERECO = 'ROLE_VISUALIZAR_DASH_ANALISE_ENDERECO',
  ROLE_VISUALIZAR_DASH_QUANTIDADE_PACIENTE = 'ROLE_VISUALIZAR_DASH_QUANTIDADE_PACIENTE',

  ROLE_PESQUISAR_ALERTA = 'ROLE_PESQUISAR_ALERTA',
  ROLE_CADASTRAR_ALERTA = 'ROLE_CADASTRAR_ALERTA',
  ROLE_REMOVER_ALERTA = 'ROLE_REMOVER_ALERTA',

  ROLE_PESQUISAR_UNIDADE = 'ROLE_PESQUISAR_UNIDADE',
  ROLE_MASTER_PESQUISAR_TENANT = 'ROLE_MASTER_PESQUISAR_TENANT',
  ROLE_MASTER_PESQUISAR_CATALOGO_USUARIO = 'ROLE_MASTER_PESQUISAR_CATALOGO_USUARIO',

  ROLE_PESQUISAR_RELATORIO_USUARIOS_POR_PERFIL = 'ROLE_PESQUISAR_RELATORIO_USUARIOS_POR_PERFIL',
  ROLE_PESQUISAR_RELATORIO_PERMISSOES_POR_PERFIL = 'ROLE_PESQUISAR_RELATORIO_PERMISSOES_POR_PERFIL',

  ROLE_PESQUISAR_PARAMETRO = 'ROLE_PESQUISAR_PARAMETRO',
  ROLE_CADASTRAR_PARAMETRO = 'ROLE_CADASTRAR_PARAMETRO',
  ROLE_PESQUISAR_ROTINA = 'ROLE_PESQUISAR_ROTINA',
  ROLE_CADASTRAR_ROTINA = 'ROLE_CADASTRAR_ROTINA',
  ROLE_CADASTRAR_POLITICA_DE_PRIVACIDADE = 'ROLE_CADASTRAR_POLITICA_DE_PRIVACIDADE',

  ROLE_PESQUISAR_IMPORTACAO_NFE = 'ROLE_PESQUISAR_IMPORTACAO_NFE',
  ROLE_CADASTRAR_IMPORTACAO_NFE = 'ROLE_CADASTRAR_IMPORTACAO_NFE',
  ROLE_REMOVER_IMPORTACAO_NFE = 'ROLE_REMOVER_IMPORTACAO_NFE',

  ROLE_PESQUISAR_RELATORIO_ESTOQUE = 'ROLE_PESQUISAR_RELATORIO_ESTOQUE',
  ROLE_PESQUISAR_RELATORIO_INVENTARIO = 'ROLE_PESQUISAR_RELATORIO_INVENTARIO',
  ROLE_PESQUISAR_RELATORIO_MEDICACAO_LOTE = 'ROLE_PESQUISAR_RELATORIO_MEDICACAO_LOTE',
  ROLE_PESQUISAR_RELATORIO_NOTA_FISCAL = 'ROLE_PESQUISAR_RELATORIO_NOTA_FISCAL',

  ROLE_PESQUISAR_QUESTIONARIO = 'ROLE_PESQUISAR_QUESTIONARIO',
  ROLE_CADASTRAR_QUESTIONARIO = 'ROLE_CADASTRAR_QUESTIONARIO',
  ROLE_REMOVER_QUESTIONARIO = 'ROLE_REMOVER_QUESTIONARIO',

  ROLE_PESQUISAR_SALA_MEDICACAO = 'ROLE_PESQUISAR_SALA_MEDICACAO',
  ROLE_CADASTRAR_SALA_MEDICACAO = 'ROLE_CADASTRAR_SALA_MEDICACAO',
  ROLE_REMOVER_SALA_MEDICACAO = 'ROLE_REMOVER_SALA_MEDICACAO',

  ROLE_PESQUISAR_ALERGIA = 'ROLE_PESQUISAR_ALERGIA',
  ROLE_CADASTRAR_ALERGIA = 'ROLE_CADASTRAR_ALERGIA',
  ROLE_REMOVER_ALERGIA = 'ROLE_REMOVER_ALERGIA',

  ROLE_PESQUISAR_ATENDIMENTO = 'ROLE_PESQUISAR_ATENDIMENTO',
  ROLE_CADASTRAR_ATENDIMENTO = 'ROLE_CADASTRAR_ATENDIMENTO',
  ROLE_REMOVER_ATENDIMENTO = 'ROLE_REMOVER_ATENDIMENTO',

  ROLE_PESQUISAR_ATENDIMENTO_SALA = 'ROLE_PESQUISAR_ATENDIMENTO_SALA',
  ROLE_CADASTRAR_ATENDIMENTO_SALA = 'ROLE_CADASTRAR_ATENDIMENTO_SALA',
  ROLE_REMOVER_ATENDIMENTO_SALA = 'ROLE_REMOVER_ATENDIMENTO_SALA',
  ROLE_REALIZAR_ATENDIMENTO_SALA = 'ROLE_REALIZAR_ATENDIMENTO_SALA',

  ROLE_REMOVER_MEDICACAO_LOTE = 'ROLE_REMOVER_MEDICACAO_LOTE',
  ROLE_CADASTRAR_MEDICACAO_LOTE = 'ROLE_CADASTRAR_MEDICACAO_LOTE',
  ROLE_PESQUISAR_MEDICACAO_LOTE = 'ROLE_PESQUISAR_MEDICACAO_LOTE',

  ROLE_PESQUISAR_AGENDAMENTO = 'ROLE_PESQUISAR_AGENDAMENTO',
  ROLE_CADASTRAR_AGENDAMENTO = 'ROLE_CADASTRAR_AGENDAMENTO',
  ROLE_REMOVER_AGENDAMENTO = 'ROLE_REMOVER_AGENDAMENTO',
  ROLE_GERAR_ROTAS = 'ROLE_GERAR_ROTAS',

  ROLE_PESQUISAR_TIPO_COLETA = 'ROLE_PESQUISAR_TIPO_COLETA',
  ROLE_CADASTRAR_TIPO_COLETA  = 'ROLE_CADASTRAR_TIPO_COLETA',
  ROLE_REMOVER_TIPO_COLETA = 'ROLE_REMOVER_TIPO_COLETA',

  ROLE_PESQUISAR_ESTABELECIMENTO = 'ROLE_PESQUISAR_ESTABELECIMENTO',
  ROLE_CADASTRAR_ESTABELECIMENTO = 'ROLE_CADASTRAR_ESTABELECIMENTO',
  ROLE_REMOVER_ESTABELECIMENTO = 'ROLE_REMOVER_ESTABELECIMENTO',

  ROLE_PESQUISAR_AGENDA = 'ROLE_PESQUISAR_AGENDA',
  ROLE_CADASTRAR_AGENDA = 'ROLE_CADASTRAR_AGENDA',
  ROLE_REMOVER_AGENDA = 'ROLE_REMOVER_AGENDA',

  ROLE_PESQUISAR_DAY_OFF = 'ROLE_PESQUISAR_DAY_OFF',
  ROLE_CADASTRAR_DAY_OFF = 'ROLE_CADASTRAR_DAY_OFF',
  ROLE_REMOVER_DAY_OFF = 'ROLE_REMOVER_DAY_OFF',

  // CFG_INTEGRACAO
  ROLE_PESQUISAR_CFG_INTEGRACAO_EVENTO = 'ROLE_PESQUISAR_CFG_INTEGRACAO_EVENTO',
  ROLE_PESQUISAR_CFG_INTEGRACAO_EVENTO_CLIENTE = 'ROLE_PESQUISAR_CFG_INTEGRACAO_EVENTO_CLIENTE',
  ROLE_REMOVER_CFG_INTEGRACAO_EVENTO_CLIENTE = 'ROLE_REMOVER_CFG_INTEGRACAO_EVENTO_CLIENTE',
  ROLE_CADASTRAR_CFG_INTEGRACAO_EVENTO_CLIENTE = 'ROLE_CADASTRAR_CFG_INTEGRACAO_EVENTO_CLIENTE',
  ROLE_PESQUISAR_CFG_INTEGRACAO_EVENTO_LOG = 'ROLE_PESQUISAR_CFG_INTEGRACAO_EVENTO_LOG',
  ROLE_CADASTRAR_CFG_INTEGRACAO_EVENTO_LOG = 'ROLE_CADASTRAR_CFG_INTEGRACAO_EVENTO_LOG',
  ROLE_REMOVER_CFG_INTEGRACAO_EVENTO_LOG = 'ROLE_REMOVER_CFG_INTEGRACAO_EVENTO_LOG',
  ROLE_PESQUISAR_CFG_INTEGRACAO_GRUPO_FUNCAO = 'ROLE_PESQUISAR_CFG_INTEGRACAO_GRUPO_FUNCAO',
  ROLE_PESQUISAR_CFG_INTEGRACAO_MODULO = 'ROLE_PESQUISAR_CFG_INTEGRACAO_MODULO',

  // DASHBOARD INTEGRACAO
  ROLE_VISUALIZAR_DASH_FALHAS_POR_INTEGRACAO = 'ROLE_VISUALIZAR_DASH_FALHAS_POR_INTEGRACAO',
  ROLE_VISUALIZAR_DASH_CONSUMO_POR_INTEGRACAO = 'ROLE_VISUALIZAR_DASH_CONSUMO_POR_INTEGRACAO',

  // RELEASE NOTES
  ROLE_PESQUISAR_RELEASE_NOTE = 'ROLE_PESQUISAR_RELEASE_NOTE',
  ROLE_CADASTRAR_RELEASE_NOTE = 'ROLE_CADASTRAR_RELEASE_NOTE',
  ROLE_REMOVER_RELEASE_NOTE = 'ROLE_REMOVER_RELEASE_NOTE',

  ROLE_PESQUISAR_CONFIGURACAO_ROTA = 'ROLE_PESQUISAR_CONFIGURACAO_ROTA',
  ROLE_CADASTRAR_CONFIGURACAO_ROTA = 'ROLE_CADASTRAR_CONFIGURACAO_ROTA',
  ROLE_REMOVER_CONFIGURACAO_ROTA = 'ROLE_REMOVER_CONFIGURACAO_ROTA',

  // ASSINATURA DIGITAL
  ROLE_PESQUISAR_ASSINATURA_DIGITAL_EVENTO = 'ROLE_PESQUISAR_ASSINATURA_DIGITAL_EVENTO',
  ROLE_CADASTRAR_ASSINATURA_DIGITAL_EVENTO = 'ROLE_CADASTRAR_ASSINATURA_DIGITAL_EVENTO',
  ROLE_PESQUISAR_ASSINATURA_DIGITAL_PIN = 'ROLE_PESQUISAR_ASSINATURA_DIGITAL_PIN',
  ROLE_CADASTRAR_ASSINATURA_DIGITAL_PIN = 'ROLE_CADASTRAR_ASSINATURA_DIGITAL_PIN'
}
